import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, inject } from "@angular/core";
import { EnvConfig, Environment } from "@doc/core";
import { ApiUrls } from "../backoffice-urls";

@Injectable({
  providedIn: "root",
})
export class AiServiceService {
  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(@Inject(EnvConfig) private config: Environment) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  CallAiOnApproval(id: any) {
    const link = this.apiUrl + ApiUrls.CallAiOnApproval;
    return this.http.post<any>(link, id);
  }

  SearchAndAnswerAi(id: any, isChat:boolean) {
    const url = isChat ? ApiUrls.SearchAndAnswerAi : ApiUrls.SearchAi
    const link = this.apiUrl + url;
    return this.http.post<any>(link, id);
  }

  DeleteAi(id: any) {
    const link = this.apiUrl + ApiUrls.DeleteAi;
    return this.http.post<any>(link, id);
  }
}
